import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Page } from "@models/page";
import { EventCardComponent } from "@shared/components/cards/event-card/event-card.component";
import { PaginatorReportComponent } from "@shared/components/paginator-report/paginator-report.component";
import { PaginatorModule, PaginatorState } from "primeng/paginator";
import { SkeletonModule } from "primeng/skeleton";
import { LoadingComponent } from "../../../../../shared/components/loading/loading.component";
import { EventInfoResponseBody } from "../../../../services/types/events-management-response.type";

@Component({
  selector: "app-events-list",
  imports: [
    SkeletonModule,
    EventCardComponent,
    PaginatorModule,
    PaginatorReportComponent,
    LoadingComponent,
  ],
  templateUrl: "./events-list.component.html",
  styleUrl: "./events-list.component.scss",
})
export class EventsListComponent {
  @Input() eventsPage: Page<EventInfoResponseBody> | null = null;
  @Input() isLoading = false;

  @Output() pageChangeClick = new EventEmitter<PaginatorState>();

  first = 0;
  rows = 20;

  handlePageChange(page: PaginatorState) {
    this.pageChangeClick.emit(page);
  }
}
